<template>
  <NxInput
    :name="name"
    type="text"
    :label="label"
    :placeholder="placeholder"
    :maxlength="maxlength"
    @update:value="handleValueUpdate"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'
export default {
  name: 'NxInputText',
  mixins: [useReactiveModelMixin('value')],
  props: {
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val ? encodeURIComponent(val) : val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputText.vue